<template>
    <el-dialog v-model="visible" :show-close="false" width="700" :modal="false" :draggable="true" @click.stop >
        <template #header="{ close, titleId, titleClass }">
            <div class="data-table-header">
                <h4 :id="titleId" :class="titleClass">选择目录</h4>
                <div class="data-table-close" @click.stop="close">×</div>
            </div>
        </template>
        <div class="data-table">
            <el-table :data="objectList" style="width: 100%">
                <el-table-column type="selection" width="55" />

                <el-table-column property="item.title" label="标题" />
                <el-table-column property="item.description" label="描述" show-overflow-tooltip />
            </el-table>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'DataTablePanel',
    data() {
        return {
            visible: false,
        }
    },
    props: {
        objectList: {
            type: Array, 
            required: true // 表示该参数是必需的
        }
    },
    mounted() {


    },
    methods: {
        open() {
            this.visible = true;
        },


    }
}

</script>

<style scoped>
.data-table {
    padding: 10px;
}

.el-dialog {
    padding: 0px !important;
}

.data-table-close {
    color: #fff;
    font-size: 26px;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
}

.data-table-header {
    position: relative;
    height: 46px;
    padding: 12px;
    background-color: #1b2d3e;
    color: #fff;
    border-radius:
        5px 5px 0 0;

}

.data-table-header h4 {
    color: #fff;
}
</style>